import { loadScript } from '@utils/index';
import { processEnv } from '@utils/config';

const h5_fe_lib =
  processEnv.hostEnv == 'online'
    ? '//h5cdn.babytreeimg.com'
    : '//h5cdn-1.babytree-test.com';

export function lazyWLA() {
  if (window.WLA) {
    return Promise.resolve(window.WLA);
  } else {
    return loadScript(
      `${h5_fe_lib}/h5_fe_lib/release/wla/0.0.12/index.min.js`,
      {
        attrs: { crossorigin: 'anonymous' }
      }
    ).then(() => {
      return window.WLA;
    });
  }
}

export function lazyMonitor() {
  if (window.bbtMonitor) {
    return Promise.resolve(window.bbtMonitor);
  } else {
    return loadScript(
      `${h5_fe_lib}/h5_fe_lib/release/monitor/2.0.5/index.min.js`,
      {
        attrs: { crossorigin: 'anonymous' }
      }
    ).then(() => {
      return window.bbtMonitor;
    });
  }
}

// APM监控
export function lazyBrowserClient() {
  if (window.browserClient) {
    return Promise.resolve(window.browserClient);
  } else {
    return new Promise((resolve, reject) => {
      import('@apmplus/web')
        .then(browserClient => {
          window.browserClient = browserClient.default;
          resolve(browserClient.default);
        })
        .catch(() => reject());
    });
  }
}

export function lazyDingTalkSdk() {
  if (window.dingTalkSdk) {
    return Promise.resolve(window.dingTalkSdk);
  } else {
    return new Promise((resolve, reject) => {
      import('dingtalk-jsapi')
        .then(dingTalkSdk => {
          window.dingTalkSdk = dingTalkSdk.default;
          resolve(dingTalkSdk.default);
        })
        .catch(() => reject());
    });
  }
}

export function lazyWeixinJsSdk() {
  if (window.wx) {
    return Promise.resolve(window.wx);
  } else {
    return loadScript(`/static/js/jweixin-1.6.0.js`, {
      attrs: { crossorigin: 'anonymous' }
    }).then(() => {
      return window.wx;
    });
  }
}
